import {getCategoryList} from "../../http/home";

export default {
  state:{
    categories:[],
    cmsEducational:[],
    cmsCountry:[],
    cmsLx:[],
    cmsPx:[],
    cmsCampus:[],
    campusCode: 'cms.campus.zz',
    cmsCompany:[],
    companyCode: 'cms.company.zz',
    currentCompany: {
      code: 'cms.company.zz',
      "name": "郑州站",
      phone: '0371-55901959',
      addr: '河南省郑州市金水区花园路126号 1号楼37楼3701-3703室'
    }
  },
  actions:{
    async fetchCategories({commit}){
      const res = await getCategoryList({pCode: 'cms'})
      if(res.code == 200){
        const data = res.result ||[]
        console.log('🚀🚀🚀 file:src/store/modules/category.js line: 26 :',data)
        commit('setCategories',data)
      }

    },
    async fetchCampusCode({commit},payload){
      commit('setCampusCode',payload)
    },
    async fetchCompanyCode({commit},payload){
      commit('setCompanyCode',payload)
    }
  },
  mutations:{
    setCategories:(state,payload)=>{
      state.categories = payload
      for (const key in payload) {
        switch (payload[key].code) {
          case 'cms.educational':  // 学历
            state.cmsEducational = payload[key].children
            break;
          case 'cms.country':  // 国家
            state.cmsCountry = payload[key].children
            break;
          case 'cms.lx':  // 留学资讯标签
            state.cmsLx = payload[key].children
            break;
          case 'cms.px':  // 培训资讯标签
            state.cmsPx = payload[key].children
            break;
          case 'cms.campus':  // 校区
            console.log('🚀🚀🚀 file:src/store/modules/category.js line: 48 :',payload[key].children)
            state.cmsCampus= payload[key].children
            break;
          case 'cms.company': // 公司
            state.cmsCompany = payload[key].children

        }
      }
    },
    setCampusCode: (state,payload) => {
      state.campusCode = payload
    },
    setCompanyCode: (state, payload) => {
      const data = {
        'cms.company.zz':{
          code: 'cms.company.zz',
          "name": "郑州站",
          phone: '0371-55901959',
          addr: '河南省郑州市金水区花园路126号 1号楼37楼3701-3703室'
        },
        "cms.company.wh":{
          code: 'cms.company.wh',
          "name": "武汉站",
          phone: '027-87870078',
          addr: '湖北省武汉市洪山区珞喻路 10 号百脑汇写字楼（群光中心）2812-2818 室',
        },
        "cms.company.hz":{
          code: 'cms.company.hz',
          name: "杭州站",
          phone: '0571-87963209',
          addr: '杭州市拱墅区绿地中央广场5幢1303'
        },
        "cms.company.sz":{
          code: 'cms.company.sz',
          "name": "深圳站",
          phone: '16675179966',
          addr: '深圳市福田区金田路卓越世纪中心4号楼2408A'
        }
      }
      state.companyCode = payload
      state.currentCompany = data[payload]
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js